import { Box, Flex, styled, UnstyledButton, CellRemove } from '@chilipiper/design-system'

export const StyledVideo = styled.video`
  min-height: 264px;
  height: 100%;
  object-fit: cover;
  display: block;
  max-width: 100%;
  grid-area: 1/-1;
`

export const StyledVideoOverlayContent = styled(Flex)`
  grid-area: 1/-1;
  z-index: 2;
  flex-direction: column;
`

export const StyledGradientOverlay = styled(Box)`
  grid-area: 1/-1;
  z-index: 1;
`

export const StyledContainer = styled(Box)`
  position: relative;
  background: ${({ theme }) => theme.colors['bg/minor']};

  ::after {
    content: '';
    position: absolute;
    z-index: 1;
    inset: 0;
    pointer-events: none;
    border-radius: ${({ theme }) => theme.radii[12]};
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors['bg/chat-scrollbar-control']} inset;
  }
`

export const StyledCellRemove = styled(CellRemove)`
  :not(:disabled) {
    :hover,
    :focus-visible {
      background: ${({ theme }) => theme.colors['red-light-100']};
      opacity: 1;
    }
  }
`

export const StyledIconButton = styled(UnstyledButton)<{ isGreenBg: boolean }>`
  :not(:disabled) {
    background: ${({ theme, isGreenBg }) =>
      isGreenBg ? theme.colors['green-light-48'] : theme.colors['neutral-dark-48']};

    :hover,
    :focus-visible {
      opacity: 1;
      background: ${({ theme, isGreenBg }) =>
        isGreenBg ? theme.colors['green-light-64'] : theme.colors['neutral-dark-64']};
    }
  }
`
